/**
 * Money helpers. Everything is stored as integer cents + an ISO currency
 * code; formatting happens at the edge.
 */

export function formatMoney(cents: number, currency = 'USD', locale?: string): string {
  const safe = Number.isFinite(cents) ? cents : 0;
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(safe / 100);
  } catch {
    return `$${(safe / 100).toFixed(2)}`;
  }
}

/** "12.5" / "$12.50" / "12,50" → 1250. Returns null for unparseable input. */
export function parseMoneyToCents(input: string): number | null {
  const cleaned = input.replace(/[^0-9.,-]/g, '').replace(',', '.');
  if (!cleaned) return null;
  const n = Number(cleaned);
  if (!Number.isFinite(n) || n < 0) return null;
  return Math.round(n * 100);
}

/** 1250 → "12.50" (no currency symbol — for inputs). */
export function centsToInput(cents: number | null | undefined): string {
  if (cents == null || !Number.isFinite(cents)) return '';
  return (cents / 100).toFixed(2);
}
